// extracted by mini-css-extract-plugin
export default {"root":"EditDurationModalSuccessStage_root__brPf3","success":"EditDurationModalSuccessStage_success__-idBO"};